<template>
    <!--v-card class="elevation-0"-->
    <v-flex id="menuLateral"  v-if="menuLateralDrawer">

        <v-list >
            <v-btn
            class="repeatOrderLink"
            v-on:click.prevent.stop="lastOrder(true)"
            color="primary"
            @click="dialog = false"
          >
            Repetir último pedido
            </v-btn>
            
            <v-list-tile @click="optsChange()">
                <v-list-tile-action>
                <v-checkbox
                    v-model="onlyAvailable"
                ></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content @click.prevent="onlyAvailable = !onlyAvailable">
                <v-list-tile-title class="body-1">Disponibles</v-list-tile-title>
                <v-list-tile-sub-title class="caption">Solo productos con disponibilidad</v-list-tile-sub-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="optsChange()">
                <v-list-tile-action>
                <v-checkbox
                    v-model="topventas"
                ></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content @click.prevent="topventas = !topventas">
                <v-list-tile-title class="body-1">Top Ventas</v-list-tile-title>
                <v-list-tile-sub-title class="caption">{{$store.state.appconfig.topItems}} mas vendidos</v-list-tile-sub-title>
                </v-list-tile-content>
            </v-list-tile>
            <!--v-list-tile @click="optsChange()">
                <v-list-tile-action>
                <v-checkbox
                    v-model="grupos"
                ></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content @click.prevent="grupos = !grupos">
                <v-list-tile-title class="body-1">Agrupar</v-list-tile-title>
                <v-list-tile-sub-title class="caption">Separar por grupos de producto</v-list-tile-sub-title>
                </v-list-tile-content>
            </v-list-tile-->
            <v-list-tile @click="promosChange()" v-if="$store.state.appconfig.promociones">
                <v-list-tile-action>
                <v-checkbox
                    v-model="onlyPromos"
                ></v-checkbox>
                </v-list-tile-action>

                <v-list-tile-content @click.prevent="onlyPromos = !onlyPromos">
                <v-list-tile-title class="body-1">Promociones</v-list-tile-title>
                <v-list-tile-sub-title class="caption">Solo artículos con promoción</v-list-tile-sub-title>
                </v-list-tile-content>
            </v-list-tile>    
        <!--v-flex v-if="!topventas"-->
        <v-flex>
        <v-list-group
            v-for="item in menuitems"
            :key="item.title"
            v-model="item.active"
            :prepend-icon="item.action"                                 
        >
            <template v-slot:activator>
                <v-list-tile>
                    <v-list-tile-content>
                    <v-list-tile-title class="body-1">{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </template>
            <v-container
            id="scroll-target"
            :style="maxHeight"
            class="scroll-y"
            fluid
            pa-0
            >       
            <v-list dense>
                <v-list-group
                v-for="subItem in item.items"
                :key="subItem.Code"
                v-model="subItem.active"   
                no-action    
                @click.capture="handleListCLick(subItem,$event)"                                             
                >     
                <template v-slot:activator >
                <v-list-tile >
                    <v-list-tile-action>
                        <v-checkbox 
                        v-model="subItem.allow"
                        @change="checkedCat(subItem)">
                        </v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title class="body-1">{{ subItem.description }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                </template>
                <v-list-tile pa-0               
                v-for="subCat in subItem.subCategories"
                :key="subCat.code"                
                >
                    <v-list-tile-action>
                        <v-checkbox 
                        v-model="subCat.allow"
                        @change="checkedSubCat(subItem,subCat)">
                        </v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title class="caption">{{ subCat.description }}</v-list-tile-title>
                    </v-list-tile-content>                
                </v-list-tile>
                </v-list-group>
            </v-list>
                <!--v-list-tile pa-0               
                v-for="subItem in item.items"
                :key="subItem.code"                
                >
                    <v-list-tile-action>
                        <v-checkbox 
                        v-model="subItem.allow"
                        @change="checked()">
                        </v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title class="caption">{{ subItem.description }}</v-list-tile-title>
                    </v-list-tile-content>                
                </v-list-tile-->
            </v-container>
        </v-list-group>
        </v-flex>           
        </v-list>
    <!--/v-card-->
    </v-flex>
</template>
<script>
//import mixin from '@/components/mixin.js'
export default {
    //mixins:[mixin],
    name: 'menulateral',
    data () {
        return {   
            maxHeight: 'max-height: 60vh',
        }
    },
    methods:{
        optsChange(){
            if (this.windowSize.x < 1265) this.$store.state.menuLateralDrawer = false;
            if (this.topventas) this.resetCats('');
            this.$store.state.filter = '';
            this.$store.state.onlyPromos = false;
            this.getItems();
        },
        promosChange(){
            if (this.windowSize.x < 1265) this.$store.state.menuLateralDrawer = false;
            this.$store.state.filter = '';            
            this.$store.state.orderbygroup = false;
            this.$store.state.topventas = false;
            this.$store.state.onlyAvailable = false;
            var res = this.menuitems[0].items.filter(category =>{
                return category.allow == true;
            });
            if ((res != undefined) && (res.length)){
                for (var i = 0; i < res.length; i++){
                    res[i].allow = false;
                    if (res[i].subCategories){
                        for (var j = 0; j < res[i].subCategories.length; j++){
                            res[i].subCategories[j].length
                        }
                    }
                }
            }
            this.getItems();
        },
        resetCats(cat){
            var res = this.menuitems[0].items.filter(category =>{
                return category.code != cat.code;
            });
            if ((res != undefined) && (res.length)){
                for (var i = 0; i < res.length; i++){
                    res[i].allow = false;
                    if (res[i].subCategories != null){
                        for (var j = 0; j < res[i].subCategories.length; j++){
                            res[i].subCategories[j].allow = false;
                        }
                    }
                }
            }
        },
        checkedCat(cat){
            if (this.windowSize.x < 1265) this.$store.state.menuLateralDrawer = false;
            this.topventas = false;
            this.$store.state.filter = '';
            this.$store.state.onlyPromos = false;
            //Solo 1 categoria a la vez
            this.resetCats(cat);
            //Si se desmarca la categoria, se desmarcaran todas las subcategorias            
            if (!cat.allow){
                var res = cat.subCategories.filter(subCat =>{return subCat.allow == true});
                for (var i = 0; i < res.length; i++){
                    res[i].allow = false;
                }
            } else {
                 var res = cat.subCategories.filter(subCat =>{return subCat.allow == false});
                for (var i = 0; i < res.length; i++){
                    res[i].allow = true;
                }
            }
            this.getItems();
        },
        checkedSubCat(cat,subCat){
            if (this.windowSize.x < 1265) this.$store.state.menuLateralDrawer = false;
            this.topventas = false;
            this.$store.state.filter = '';
            this.$store.state.onlyPromos = false;
            //Se resetean otras categorias
            this.resetCats(cat);
            //Solo 1 subcategoria a la vez
            var res = cat.subCategories.filter(subCategory =>{
                return subCategory.code != subCat.code;
            });                
            if ((res != undefined) && (res.length)){
                for (var i = 0; i < res.length; i++){
                    res[i].allow = false;
                }
            }
            //Si se desmarcan todas las subcategorias, se desmarca la categoria. ---> NO, comentado
            //Si se marca almenos una de las subcategorias, se marca la categoria
            var res = cat.subCategories.filter(subCat =>{return subCat.allow == true});
            if (res.length)
                cat.allow = true;            
            //else 
                //cat.allow = false;
            this.getItems();
        },
        //'Hack' para capturar el click en la lista que se solapa con el checkbox y activa tambien la lista.        
        handleListCLick(cat,$event){            
            //console.log($event);
            //console.log(cat);
            if (($event.srcElement.className == 'v-input--selection-controls__ripple' ) || 
                ($event.srcElement.className == 'v-input--selection-controls__ripple accent--text')) {
                    //$event.preventDefault(); //No funciona aqui, no evita nada
                    $event.stopPropagation(); //Detiene tambien la propagacion hacia el check
                    cat.allow = !cat.allow;
                    this.checkedCat(cat);                                  
            }            
        },
        calcMaxHeightMenu(y){
            var factor = 1000;
            factor -= y;
            factor = factor/100;
            factor = factor*factor*1.2;
            
            var vhVal = 60 - factor;
            this.maxHeight = 'max-height: ' + vhVal + 'vh';
        } 
    },
    created(){
       this.getCategories();
       this.calcMaxHeightMenu(window.innerHeight);
    },
    
    computed: {
        grupos: {
            get(){
                return this.$store.state.orderbygroup;
            },
            set(value){
                this.$store.commit('setOrderByGroup', value)
            }
        },
        topventas: {
            get(){
                return this.$store.state.topventas;
            },
            set(value){
                this.$store.commit('setTopVentas', value)
            }
        },
        onlyPromos: {
            get(){
                return this.$store.state.onlyPromos;
            },
            set(value){
                this.$store.state.onlyPromos = value;
            }
        },
        onlyAvailable: {
            get(){
                return this.$store.state.onlyAvailable;
            },
            set(value){
                this.$store.state.onlyAvailable = value;
            }
        },
        menuitems:{
            get(){
                return this.$store.state.menuitems;
            }
        },
        menuLateralDrawer:{
            get(){
                return this.$store.state.menuLateralDrawer;
            },
            set(value){
                this.$store.state.menuLateralDrawer = value;
            }
        },
        menuVerticalDrawer:{
            get(){
                return this.$store.state.menuVerticalDrawer;
            },
            set(value){
                this.$store.state.menuVerticalDrawer = value;
            }
        },
        windowSize:{
            get(){
                return this.$store.state.windowSize;
            },
            set(value){
                this.$store.state.windowSize = value;
            }
        }
    },
    watch:{        
        windowSize: function(val){
            this.calcMaxHeightMenu(val.y);
        }
    }
}
</script>
<style scoped>
 .noborderradius{
     border-radius: 0px !important;
 }
 .repeatOrderLink{
     /*text-decoration: none;*/
     width: 95%;
     height: 25px;
     font-size: small;
 }
 @media only screen and (max-width: 1264px){
    #menuLateral{
        position: absolute;         
    }
 }
 @media only screen and (min-width: 1265px){
    #menuLateral{                
    }
 }
 div.v-list--dense:nth-child(1) > div:nth-of-type(odd)
 {
    background-color: rgba(88, 151, 251, .12);
}
.v-text-field >>> label {
    font-size: small;
}
.v-text-field >>> input {
    font-size: small;
}
</style>